"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableContextDefaultValue: function() {
        return tableContextDefaultValue;
    },
    TableContextProvider: function() {
        return TableContextProvider;
    },
    useTableContext: function() {
        return useTableContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const tableContext = /*#__PURE__*/ _react.createContext(undefined);
const tableContextDefaultValue = {
    size: 'medium',
    noNativeElements: false,
    sortable: false
};
const TableContextProvider = tableContext.Provider;
const useTableContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(tableContext)) !== null && _React_useContext !== void 0 ? _React_useContext : tableContextDefaultValue;
};
